import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AlertHistoryMeta from './AlertHistoryMeta';
import {
  getAMLSCommonUnifiedAlerts,
  getAMLSCommonAlertPartyIdentity
} from '../../../redux/actions/common';

function mapStateToProps(state) {
  const { unifiedAlerts = {}, alertPartyIdentity = {} } = state.amlsCommon;
  const { data: alertHistory } = unifiedAlerts;
  const { data: customerInfo } = alertPartyIdentity;
  const { partyKey = '' } = customerInfo || {};

  return {
    alertHistory,
    isLoading: false,
    customerId: partyKey
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        getAMLSCommonAlertPartyIdentity,
        getAMLSCommonUnifiedAlerts
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertHistoryMeta);
